<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <!-- <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
  </button> -->
</div>
<div class="modal-body">
  {{ message }}
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col my-2" *ngIf="btnCancelText !=''">
      <button type="button" class="btn btn-block" (click)="accept()" id="yesBtn">{{ btnOkText }}</button>
    </div>
    <div class="col my-2" *ngIf="btnCancelText !=''">
      <button *ngIf="isNoBtnVisible" type="button" class="btn btn-block" (click)="decline()" id="cancelBtn">{{ btnCancelText }}</button>
    </div>
    <div class="col my-2" *ngIf="btnCancelText ==''">
        <button type="button" class="btn btn-block" (click)="accept()" id="yesBtn">{{ btnOkText }}</button>
      </div>
  </div>
</div>

